module.exports = __webpack_public_path__ + "assets/img/13_333_big.c682b025.jpg";